var main = function () {

    var initial = function () {
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover();

        setTimeout(function () {
            $('.blogfeed-title-wrap').dotdotdot({
                watch: "window"
            });
        }, 1500);


        $('.jog-tag-title').dotdotdot({
            watch: "window"
        });

        function go(to, offset, speed) {
            if (typeof offset === 'undefined')
                offset = 0;
            if (typeof speed === 'undefined')
                speed = 0;
            if (to === '')
                to = 0;
            else if (to !== 'undefined')
                to = $(to).offset().top - offset;
            else
                to = 0;
            if (to !== '') {
                $('body, html').animate({
                    scrollTop: to
                }, speed);
            }
        }

        var $chromeNotify = $('#getNotify');
        $chromeNotify.change(
                function () {
                    if ($chromeNotify.is(':checked')) {
                        //$("#notify_info").slideDown();
                        var notify = $.notify({message: "Enabled chrome notification"}, {type: "success", allow_dismiss: false, showProgressbar: true});
                    } else {
                        //$("#notify_info").slideUp();
                        $.notify({message: "Chrome notification disabled"}, {type: "danger"});
                    }
                });

        $.notifyDefaults({
            type: "danger",
            allow_dismiss: true,
            delay: 2000,
            timer: 1000,
            placement: {
                from: "top",
                align: "center"
            },
            animate: {
                enter: 'animated fadeInDown',
                exit: 'animated fadeOutUp'
            },
            offset: 10,
            z_index: 2000
        });

        //Initialized using the Bootstrap options:
        $('button').button({loadingText: 'Loading...'});
    };

    var menu = function () {
        jQuery.fn.fadeInOrOut = function (status) {
            return status ? this.fadeIn() : this.fadeOut();
        };

        var fadeOpen = function () {
            jQuery('#fade-me').fadeInOrOut(true);
        };
        var fadeClose = function () {
            jQuery('#fade-me').fadeInOrOut(false);
        };
        var menuActive = false;
        var profileActive = false;


        var openMenu = function () {
            menuActive = true;
            $("#menu-mobile").slideDown(300);
            $("#menu-icon").removeClass('mdi-menu');
            $("#menu-icon").addClass('mdi-close');
            closeProfile();
            return;
        };

        var closeMenu = function () {
            menuActive = false;
            $("#menu-mobile").slideUp(300);
            $("#menu-icon").removeClass('mdi-close');
            $("#menu-icon").addClass('mdi-menu');
            return;
        };

        var openProfile = function () {
            profileActive = true;
            $("#profile-nav").addClass('active');
            $("#menu-profile").removeClass('mdi-account');
            $("#menu-profile").addClass('mdi-close');
            closeMenu();
            return;
        };

        var closeProfile = function () {
            profileActive = false;
            $("#profile-nav").removeClass('active');
            $("#menu-profile").removeClass('mdi-close');
            $("#menu-profile").addClass('mdi-account');
            return;
        };

        $("#menu").click(function () {
            $('.main-header').css('zIndex', '200');
            if (menuActive === true) {
                closeMenu();
                fadeClose();
                menuActive = false;
            } else {
                openMenu();
                fadeOpen();
            }

        });

        $(".profile-menu-btn").click(function () {
            $('.main-header').css('zIndex', '1');
            if (profileActive === true) {
                closeProfile();
                fadeClose();
                profileActive = false;
            } else {
                openProfile();
                fadeOpen();
            }
            ;
        });

        $("#fade-me").click(function () {
            closeMenu();
            closeProfile();
            menuActive = false;
            profileActive = false;
            fadeClose();
            return;
        });

        $("#mLang").click(function () {

            closeMenu();
            closeProfile();
            menuActive = false;
            profileActive = false;
            fadeClose();

            return;
        });


        $(window).scroll(function () {
            var $search_bar = $(".search-bar").height();
            if ($(window).scrollTop() > $search_bar) {
                $('.profile-sub-menu-mobile,.menu-mobile').addClass('fixed');
            } else {
                $('.profile-sub-menu-mobile,.menu-mobile').removeClass('fixed');
            }
        });
    };

    var campaign = function () {
        var counter1 = false;
        var counter2 = false;
        var counter3 = false;

        $('#campaign-1').click(function () {
            var position = getPosition(this);
            var box = document.querySelector("#msg-box-1");

            if (counter1 === false) {
                counter1 = true;
                $("#msg-box-2").remove();
                $("#msg-box-3").remove();
                counter2 = false;
                counter3 = false;

                $("#campaign-1").append('<div id="msg-box-1" class="msg-box"><div class="m-header"><a class="c-danger right"><i class="mdi mdi-close"></i></a> <p class="c-primary bold"><i class="mdi mdi-gift"></i> Congratulation! You got the Bowl</p></div><div class="m-body">You are now <b>2</b>  more bowl away to win this exciting prize. Keep it Up!</div></div>');
                $("#msg-box-1").css({'top': position.y, 'left': position.x});

            } else {
                counter1 = false;
                $("#msg-box-1").remove();
            }

            return;

            function getPosition(element) {
                var xPosition = 0;
                var yPosition = 0;
                while (element) {
                    xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
                    yPosition += (element.offsetTop - element.scrollTop + element.clientTop - 40);
                    element = element.offsetParent;
                }
                return {x: xPosition, y: yPosition};
            }

        });

        $('#campaign-2').click(function () {
            var position = getPosition(this);
            if (counter2 === false) {
                counter2 = true;
                $("#msg-box-1").remove();
                $("#msg-box-3").remove();
                counter1 = false;
                counter3 = false;
                $("#campaign-2").append('<div id="msg-box-2" class="msg-box"><div class="m-header"><a class="c-danger right"><i class="mdi mdi-close"></i></a><p class="c-primary bold"> <i class="mdi mdi-gift"></i> Congratulation! You got the Bowl</p></div><div class="m-body">You are now <b>1</b>  more bowl away to win this exciting prize. Keep it Up!</div></div>');
                $("#msg-box-2").css({'top': position.y, 'left': position.x});

            } else {
                counter2 = false;
                $("#msg-box-2").remove();
            }

            function getPosition(element) {
                var xPosition = 0;
                var yPosition = 0;
                while (element) {
                    xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
                    yPosition += (element.offsetTop - element.scrollTop + element.clientTop - 40);
                    element = element.offsetParent;
                }
                return {x: xPosition, y: yPosition};
            }

        });

        $('#campaign-3').click(function () {
            var position = getPosition(this);
            if (counter3 === false) {
                counter3 = true;
                $("#msg-box-1").remove();
                $("#msg-box-2").remove();
                counter1 = false;
                counter2 = false;
                $("#campaign-3").append('<div id="msg-box-3" class="msg-box"><div class="m-header"><a class="c-danger right"><i class="mdi mdi-close"></i></a><p class="c-primary bold"><i class="mdi mdi-gift"></i> Congratulation! You got all the Bowl</p></div><div class="m-body">You have win this prize, We will contact you soon for details. Keep it Up!</div></div>');
                $("#msg-box-3").css({'top': position.y, 'left': position.x});

            } else {
                counter3 = false;
                $("#msg-box-3").remove();
            }

            function getPosition(element) {
                var xPosition = 0;
                var yPosition = 0;
                while (element) {
                    xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
                    yPosition += (element.offsetTop - element.scrollTop + element.clientTop - 40);
                    element = element.offsetParent;
                }
                return {x: xPosition, y: yPosition};
            }

        });
    };

    var blog = function () {

        // Optimalisation: Store the references outside the event handler:
        var $window = $(window);

        function checkWidth() {
            var windowsize = $window.width();
            if (windowsize < 568) {
                $(window).scroll(function () {
                    $('.blog-detail-footer-left').css('display', 'none');
                    clearTimeout($.data(this, "scrollCheck"));
                    $.data(this, "scrollCheck", setTimeout(function () {
                        $('.blog-detail-footer-left').css('display', 'block');
                    }, 100));

                });
            }
        }

        // Execute on load
        checkWidth();
        // Bind event listener
        $(window).resize(checkWidth);

        //setTimeout(function(){
        /*var $left_bar = $(".left-wrap-content:first-child");
         var $header = $(".main-header");
         var $on_scroll = $left_bar.height() + $header.height() + 15;
         var recommendedJobsBlock = $(".right-menu:first-child");
         var blogsBlock = $(".right-menu:nth-child(2)");
         var videosBlock = $(".right-menu:last-child");
         var startScrollRight = $header.height() + recommendedJobsBlock.height() + blogsBlock.height() + videosBlock.height();
         
         var onlyBlogBlock = $(".right-menu:first-child");
         var startScrollOnlyBlog = $header.height() + 15;
         
         function scroll_position(ev) {
         if (window.pageYOffset > $on_scroll) {
         $("#blog-categories").addClass('is-fixed');
         } else {
         $("#blog-categories").removeClass('is-fixed');
         }
         if (recommendedJobsBlock.height() && blogsBlock.height() && videosBlock.height()) {
         if (window.pageYOffset > startScrollRight) {
         recommendedJobsBlock.addClass('is-fixed');
         recommendedJobsBlock.css('margin-top', '15px');
         } else {
         recommendedJobsBlock.removeClass('is-fixed');
         recommendedJobsBlock.css('margin-top', '0px');
         }
         } else {
         if (window.pageYOffset > startScrollOnlyBlog) {
         onlyBlogBlock.addClass('is-fixed');
         onlyBlogBlock.css('margin-top', '15px');
         } else {
         onlyBlogBlock.removeClass('is-fixed');
         onlyBlogBlock.css('margin-top', '0px');
         }
         }
         }
         
         window.onscroll = scroll_position*/
        //console.log($on_scroll);

        //}, 3000);

        //   	$(window).scroll(function () {
        //   		var $footer = $(".footer-wrap");
        //   		var footer = $footer.height()
        //    if ($(window).scrollTop() >= $(document).height() - $(window).height() - footer) {
        //       $("#blog-post-next").addClass('show');
        // 	} else{
        // 		$("#blog-post-next").removeClass('show');
        // 	}
        // });

        // $('#blog-next-close').click(function(){
        // 	$("#blog-post-next").removeClass('show');
        // })

    };

    var layout = function () {
        // var $loginwrapper = $('.login-wrapper')
        // var $mainheader = $('.main-header')
        // var loginwrapper = $(window).height() - $mainheader.height();
        // $loginwrapper.css('height', loginwrapper)
    };

    var resize = function () {
        // $(window).resize(function () {
        //     layout()

        // });
    };

    return {
        init: function () {
            initial();
            //layout();
            menu();
            //campaign();
            blog();
            //resize();
        }
    };
}();



